import { CaretDownIcon } from '@phosphor-icons/react'
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@radix-ui/react-accordion'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

const FilterItem = ({
  name,
  options,
  counts,
  filter,
  setFilter,
}: {
  name: string
  options: { name: string }[]
  counts: Record<string, number>
  filter: { name: string }[]
  setFilter: (filter: { name: string }[]) => void
}) => {
  return (
    <AccordionItem value={name} className="border-b border-gray-300 px-3">
      <AccordionTrigger className="group flex w-full items-center justify-between py-4">
        <span className="font-bold">{name}</span>
        <div className="flex items-center">
          {filter.length > 0 && (
            <div className="flex size-6 items-center justify-center rounded-full bg-gray-100">
              <span className="text-sm font-bold">{filter.length}</span>
            </div>
          )}
          <CaretDownIcon
            size={20}
            weight="bold"
            className="ml-3 shrink-0 transition duration-150 group-data-[state=open]:rotate-180"
          />
        </div>
      </AccordionTrigger>
      <AccordionContent className="space-y-3 overflow-hidden pb-4 transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        {options.map((option) => (
          <CheckboxPrimitive.Root
            key={option.name}
            className="group flex w-full items-center"
            checked={filter.some((f) => f.name === option.name)}
            onCheckedChange={(checked) => {
              if (checked) {
                setFilter([...filter, option])
              } else {
                setFilter(filter.filter((f) => f.name !== option.name))
              }
            }}
          >
            <div className="flex flex-1 items-center space-x-3">
              <div className="box-border flex size-5 shrink-0 items-center justify-center rounded-xs border-2 border-blue-700 transition-colors duration-150 group-data-[state=checked]:bg-blue-700">
                <CheckboxPrimitive.Indicator forceMount>
                  <svg
                    width="10"
                    height="9"
                    viewBox="0 0 10 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.63388 1.11612C10.122 1.60427 10.122 2.39573 9.63388 2.88388L4.63388 7.88388C4.14573 8.37204 3.35427 8.37204 2.86612 7.88388L0.366117 5.38388C-0.122039 4.89573 -0.122039 4.10427 0.366117 3.61612C0.854272 3.12796 1.64573 3.12796 2.13388 3.61612L3.75 5.23223L7.86612 1.11612C8.35427 0.627961 9.14573 0.627961 9.63388 1.11612Z"
                      fill="#FFF"
                    />
                  </svg>
                </CheckboxPrimitive.Indicator>
              </div>
              <span className="text-left">{option.name}</span>
            </div>
            <span className="ml-2">{counts[option.name] ?? 0}</span>
          </CheckboxPrimitive.Root>
        ))}
      </AccordionContent>
    </AccordionItem>
  )
}

export default FilterItem
